import { render, staticRenderFns } from "./salesteamlead-create.vue?vue&type=template&id=2f0f9189&scoped=true&"
import script from "./salesteamlead-create.vue?vue&type=script&lang=js&"
export * from "./salesteamlead-create.vue?vue&type=script&lang=js&"
import style0 from "./salesteamlead-create.vue?vue&type=style&index=0&id=2f0f9189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f9189",
  null
  
)

export default component.exports